import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import WaitlistModal from "@/components/WaitlistModal";

const HowItWorksSection = () => {
  const [waitlistOpen, setWaitlistOpen] = useState(false);
  
  const steps = [
    {
      step: "1",
      title: "Sign Up & Explore",
      description: "Create your account and browse trails in Southern California. Research destinations and plan your next adventure using insights from the community.",
      icon: "🚀"
    },
    {
      step: "2", 
      title: "Upload Your Runs",
      description: "Share your GPX tracks from recent adventures. Our system automatically matches your routes to trail segments and helps expand the community database.",
      icon: "📤"
    },
    {
      step: "3",
      title: "Share & Earn Recognition",
      description: "Add photos, waypoints, and feedback from your runs. Unlock achievements and climb local leaderboards as you contribute to the community.",
      icon: "🏅"
    },
    {
      step: "4",
      title: "Connect & Adventure",
      description: "Join events organized by fellow off-roaders, follow other adventurers, and discover new trails from your activity feed.",
      icon: "🤝"
    }
  ];

  return (
    <section id="how-it-works" className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-6">
            How <span className="text-primary">Airing Down</span> Works
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Join a growing community of off-road adventurers sharing their experiences. 
            Every adventure you share helps others explore with confidence.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {steps.map((item, index) => (
            <Card key={index} className="relative group hover:shadow-lg transition-all duration-300 border-border/50">
              <CardContent className="p-8 text-center">
                <div className="text-6xl mb-6 group-hover:scale-110 transition-transform duration-300">
                  {item.icon}
                </div>
                <div className="text-sm font-bold text-primary mb-2 tracking-wider">
                  STEP {item.step}
                </div>
                <h3 className="text-xl font-bold text-foreground mb-4 group-hover:text-primary transition-colors">
                  {item.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {item.description}
                </p>
              </CardContent>
              
              {/* Connection Line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 w-8 h-0.5 bg-gradient-to-r from-primary to-transparent transform -translate-y-1/2 z-10" />
              )}
            </Card>
          ))}
        </div>

        <div className="text-center">
          <Button variant="hero" size="lg" className="text-lg px-8 py-6" onClick={() => setWaitlistOpen(true)}>
            Join the Adventure
          </Button>
        </div>
      </div>
      
      <WaitlistModal open={waitlistOpen} onOpenChange={setWaitlistOpen} />
    </section>
  );
};

export default HowItWorksSection;